var ApplicationPagesModule = /** @class */ (function () {
    function ApplicationPagesModule() {
    }
    return ApplicationPagesModule;
}());
export { ApplicationPagesModule };
